import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

type CompanySettingsResponse = ClientInferResponseBody<typeof contract.companySettings.update>;
export type CompanySettingsPayload = ClientInferRequest<
  typeof contract.companySettings.update
>["body"];

export const updateCompanySetting = async (
  payload: CompanySettingsPayload,
): Promise<CompanySettingsResponse | null> => {
  const response = await api.companySettings.update.mutation({
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  if (response.status === 400) {
    throw new ApiError(response.body.message, response.status, response.body);
  }

  throw new ApiError("Failed to update company settings", response.status, response.body);
};
